import React, { FC } from 'react';

const BackIcon: FC = ({}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4.84199 8L10.7765 2.25981C11.0745 1.97161 11.0745 1.50435 10.7765 1.21615C10.4786 0.927949 9.99547 0.927951 9.69751 1.21615L3.22347 7.47817C2.92551 7.76637 2.92551 8.23363 3.22347 8.52183L9.69751 14.7838C9.99547 15.072 10.4786 15.0721 10.7765 14.7839C11.0745 14.4957 11.0745 14.0284 10.7765 13.7402L4.84199 8Z" fill="#909090"/>
    </svg>
);

export default BackIcon;import React, { FC } from 'react';

const BackIcon: FC = ({}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M4.84199 8L10.7765 2.25981C11.0745 1.97161 11.0745 1.50435 10.7765 1.21615C10.4786 0.927949 9.99547 0.927951 9.69751 1.21615L3.22347 7.47817C2.92551 7.76637 2.92551 8.23363 3.22347 8.52183L9.69751 14.7838C9.99547 15.072 10.4786 15.0721 10.7765 14.7839C11.0745 14.4957 11.0745 14.0284 10.7765 13.7402L4.84199 8Z" fill="#909090"/>
    </svg>
);

export default BackIcon;